import { Session } from '@ais-ui/auth';

import { Base64String } from '../utils';

export interface ReplayOverlayMetadata {
  timeUntilNextUpdate: number;
}

export interface GetReplayOverlayProps {
  centerLat: number;
  centerLon: number;
  zoomLevel: number;
  width: number;
  height: number;
  leftLon: number;
  rightLon: number;
  timestamp: string;
  replayIdentifier: string;
}

export const getReplayOverlay = async (
  session: Session,
  props: GetReplayOverlayProps,
  timeZone: string,
): Promise<Base64String> => {
  const response = await session.request('getReplayOverlay', {
    centerLat: props.centerLat,
    centerLon: props.centerLon,
    zoomLevel: Math.round(props.zoomLevel),
    width: props.width,
    height: props.height,
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
    ran: 4,
    leftLon: props.leftLon,
    rightLon: props.rightLon,
    replayInterpolation: true,
    timestamp: props.timestamp,
    replayIdentifier: props.replayIdentifier,
    applicationName: 'marinepulse',
    timeZone: timeZone,
  });

  return response;
};

export const getReplayOverlayMetadata = async (
  session: Session,
): Promise<ReplayOverlayMetadata> => {
  const response = await session.request('getTargetInfo', {});

  return response;
};
